import Sites from "../models/Sites";

const SiteStore = Sites.create();

export default SiteStore;
